import config from './config';

async function apiFetch(path, options = {}, token) {
  const res = await fetch(`${config.apiUrl}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      Authorization: token,
      ...options.headers,
    },
  });
  return res.json();
}

export async function createSession(data, token) {
  return apiFetch('/sessions', { method: 'POST', body: JSON.stringify(data) }, token);
}

export async function startSession(sessionId, token) {
  return apiFetch(`/sessions/${sessionId}/start`, { method: 'POST', body: '{}' }, token);
}

export async function getSession(sessionId, token) {
  return apiFetch(`/sessions/${sessionId}`, {}, token);
}

export async function listSessions(token, filters = {}) {
  const params = new URLSearchParams();
  if (filters.status) params.set('status', filters.status);
  if (filters.date_from) params.set('date_from', filters.date_from);
  if (filters.date_to) params.set('date_to', filters.date_to);
  if (filters.client) params.set('client', filters.client);
  if (filters.meeting) params.set('meeting', filters.meeting);
  if (filters.page) params.set('page', filters.page);
  if (filters.page_size) params.set('page_size', filters.page_size);
  const query = params.toString() ? `?${params}` : '';
  return apiFetch(`/sessions${query}`, {}, token);
}

export async function deleteSession(sessionId, token) {
  return apiFetch(`/sessions/${sessionId}`, { method: 'DELETE' }, token);
}

export async function reprocessSession(sessionId, data, token) {
  return apiFetch(`/sessions/${sessionId}/reprocess`, { method: 'POST', body: JSON.stringify(data) }, token);
}

export async function updateSession(sessionId, data, token) {
  return apiFetch(`/sessions/${sessionId}`, { method: 'PATCH', body: JSON.stringify(data) }, token);
}